import { Box, CircularProgress } from "@mui/material";
import CenterContent from "./CenterContent";

function SpaPending() {
  return (
    <CenterContent drawerDisabled>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          height: "100%",
          minHeight: "100%",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}>
        <CircularProgress size={50} />
      </Box>
    </CenterContent>
  );
}

export default SpaPending;
